<template>
  <div class="my-div-center">
    <div id="main" style="height: 600px;width: 600px" ></div>
  </div>
</template>

<script>
import * as echarts from 'echarts/core';
import { GridComponent } from 'echarts/components';
import { ScatterChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([GridComponent, ScatterChart, CanvasRenderer, UniversalTransition]);


export default {
  name: "test2",
  data() {
    return{
      img_path: '',
      SVG_data: [],
    }
  },
  methods: {
    initEcharts(){
      const chartDom = document.getElementById('main');
      const myChart = echarts.init(chartDom);
      let option;

      const schema = [
        { name: 'x', index: 0, text: 'x' },
        { name: 'y', index: 1, text: 'y' },
        { name: 'gene', index: 2, text: 'gene' },
        { name: 'expression', index: 3, text: 'expression' },
      ];
      // const itemStyle = {
      //   emphasis: {
      //     focus : 'self'
      //   }
      // };
      option = {
        tooltip: {
          backgroundColor: 'rgba(255,255,255,0.7)',
          formatter: function (param) {
            // console.log(param)
            var value = param.value;
            // prettier-ignore
            return '<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
                + schema[2].text + '：' + value[2]
                + '</div>'
                + schema[0].text + '：' + value[0] + '<br>'
                + schema[1].text + '：' + value[1] + '<br>'
                + schema[3].text + '：' + value[3] + '<br>';
          }
        },
        toolbox: {
          feature: {
            saveAsImage: {
              show: true,
              title: "save",
              name: "marker.png",
            },
          },
        },
        xAxis: {},
        yAxis: {},
        series: [
          {
            symbolSize: 20,
            data: [
              [1, 1,'a',20],
              [8.07, 6.95],
              [13.0, 7.58],
              [9.05, 8.81],
              [11.0, 8.33],
              [14.0, 7.66],
              [13.4, 6.81],
              [10.0, 6.33],
              [14.0, 8.96],
              [12.5, 6.82],
              [9.15, 7.2],
              [11.5, 7.2],
              [3.03, 4.23],
              [12.2, 7.83],
              [2.02, 4.47],
              [1.05, 3.33],
              [4.05, 4.96],
              [6.03, 7.24],
              [12.0, 6.26],
              [12.0, 8.84],
              [7.08, 5.82],
              [5.02, 5.68]
            ],
            type: 'scatter'
          }
        ]
      };
      option && myChart.setOption(option);

    },
  },
  mounted() {
    this.initEcharts()
  }
}

</script>

<style scoped>

</style>
